import * as React from "react";
import * as ReactDOM from "react-dom";

interface IProperties
{
    /**
     * Inline-Style.
     */
    style?: React.CSSProperties,

    /**
     * Anzeige Text.
     */
    text: string;

    /**
     * Der zugeordnete Monat.
     */
    month: number;

    /**
     * Das zugeordnete Jahr.
     */
    year: number;

    /**
     * Wird ausgeführt, sobald auf das Item geklickt wird.
     */
    onClick?: (month: number, year: number) => void;
}

export class MonthItem extends React.Component<IProperties>
{
    /**
     * Führt die "onClick" Eigenschaft aus wenn diese gesetzt wurde.
     * @param e Das auslösende Ereignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>) =>
    {
        var { month, year, onClick } = this.props;
        onClick && onClick(month, year);
    }

    /**
     * Rendert die Komponente.
     */
    public render(): JSX.Element
    {
        return (
            <div
                className="datepicker_months_item"
                style={this.props.style}
                onClick={this.onClick}>
                {this.props.text}
            </div>
        );
    }
}